(function(){
  function pad(n){return String(n).padStart(2,'0');}
  function initCd(el){
    if(el.dataset.bound)return;el.dataset.bound='1';
    var dl,midnight=el.dataset.mode!=='per_visitor';
    function nextMidnight(){var d=new Date();d.setHours(24,0,0,0);return d.getTime();}
    if(midnight){dl=nextMidnight();}else{
      var KEY='t300_deadline',dur=(parseFloat(el.dataset.hours)||14)*3600*1000;
      try{dl=parseInt(localStorage.getItem(KEY)||'0',10);}catch(e){dl=0;}
      if(!dl||dl<Date.now()){dl=Date.now()+dur;try{localStorage.setItem(KEY,String(dl));}catch(e){}}
    }
    var h=el.querySelector('.cd-h'),m=el.querySelector('.cd-m'),s=el.querySelector('.cd-s');
    function tick(){if(midnight&&Date.now()>=dl)dl=nextMidnight();var r=Math.max(0,Math.floor((dl-Date.now())/1000));h.textContent=pad(Math.floor(r/3600));m.textContent=pad(Math.floor(r%3600/60));s.textContent=pad(r%60);}
    tick();setInterval(tick,1000);
  }
  function initFaq(root){
    root.querySelectorAll('.t300-faq-q').forEach(function(btn){
      if(btn.dataset.bound)return;btn.dataset.bound='1';
      btn.addEventListener('click',function(){
        var it=btn.parentElement,open=it.classList.contains('open');
        root.querySelectorAll('.t300-faq-item.open').forEach(function(o){o.classList.remove('open');o.querySelector('.x').textContent='+';});
        if(!open){it.classList.add('open');btn.querySelector('.x').textContent='\u2212';}
      });
    });
  }
  function initAll(scope){
    (scope||document).querySelectorAll('[data-t300-cd]').forEach(initCd);
    (scope||document).querySelectorAll('[data-t300-faq]').forEach(initFaq);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initAll();});}else{initAll();}
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();
